const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function normalizeAgentIdParam(value) {
  const candidate = (value || '').trim();
  return UUID_PATTERN.test(candidate) ? candidate : '';
}

export function formatPeriodKey(periodKey) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(periodKey || '');
  if (!match) return periodKey || 'Período não informado';
  return `${match[3]}/${match[2]}/${match[1]}`;
}

export function formatUpdatedAt(value) {
  if (!value) return 'Data não informada';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
    timeZone: 'America/Sao_Paulo',
  }).format(date);
}

export function splitRecommendedActionsSection(markdown, hasStructuredActions) {
  if (!hasStructuredActions || !markdown) {
    return { before: markdown || '', after: '' };
  }

  const sectionStart = markdown.search(/^## Ações recomendadas\s*$/im);
  if (sectionStart < 0) return { before: markdown, after: '' };

  const afterHeading = markdown.slice(sectionStart).search(/\n## (?!#)/);
  if (afterHeading < 0) {
    return { before: markdown.slice(0, sectionStart).trimEnd(), after: '' };
  }

  return {
    before: markdown.slice(0, sectionStart).trimEnd(),
    after: markdown.slice(sectionStart + afterHeading + 1).trimStart(),
  };
}

export function hasCaseReferences(markdown) {
  return /\bC-[a-z0-9]+\b/i.test(markdown || '');
}
